export default "__VITE_ASSET__BEisxpFV__"